import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import { FaFemale, FaMale } from "react-icons/fa";

import { capitalizeFirstLetter, getRole, truncateText } from "../../helpers";
import moment from "moment";
import Tooltip from "../Tooltip";

const Tables = ({ apiData, setSelectedData }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.name);

    return (
      <div className="flex items-center gap-3">
        {/* Avatar / Gender */}
        <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center">
          {item.gender === 1 ? (
            <FaMale className="text-blue-500" />
          ) : (
            <FaFemale className="text-pink-500" />
          )}
        </div>

        {/* Details */}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-medium text-gray-600 truncate max-w-[140px]">
              {truncateText(name, 25)}
            </span>
          </div>

          {/* <div className="flex items-center gap-1 text-xs text-gray-400">
            #{item.mobile}
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="opacity-0 group-hover:opacity-100 transition"
            >
              <IoCopySharp size={12} />
            </button>
          </div> */}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        mobile: item.mobile,
        checkIn: getTime(item),
        createdAt: item?.lastLogin ? getLastLogin(item?.lastLogin) : getLastLogin(item.createdAt),
        salary: item?.salary ? '₹' + item.salary : 'N/A',
        attendanceStatus: getAttendanceStatus(item),
        mobile: <span className='text-gray-600 text-sm'>{'#' + item.mobile}</span>,
        role: <span className="text-xs px-2 py-1 rounded-md border border-gray-200 text-gray-600 bg-gray-50">
          {getRole(item.role)}</span>,
        // status:
        //   item.status == 1 ? (
        //     <div className="bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full">
        //       Active
        //     </div>
        //   ) : (
        //     <div className="bg-gray-100 text-gray-700 text-xs border-gray-300 border w-24 h-7 flex items-center justify-center rounded-full">
        //       Inactive
        //     </div>
        //   ),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getAttendanceStatus = (item) => {
    if (item.attendance === 1) {
      return <p className="bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg">Present</p>;
    } else {
      return <p className="bg-rose-50 text-rose-700 text-xs border-rose-100 border w-24 h-7 flex items-center justify-center rounded-lg">Absent</p>;
    }
  };

  const getLoginTimeColor = (lastLogin) => {
    if (!lastLogin) return "#9CA3AF"; // Grey - Never logged in

    const days = moment().diff(moment(lastLogin), "days");

    if (days <= 1) return "bg-green-50";   // Green
    if (days <= 3) return "bg-yellow-50";   // Yellow
    if (days <= 7) return "bg-orange-50";   // Orange

    return "bg-rose-50";                 // Red
  };

  // const getLastLogin = (lastLogin) => {
  //   let bgColor = getLoginTimeColor(lastLogin);
  //   return <span className={`${bgColor} px-3 py-1 rounded-md text-gray-600 text-sm`}>{moment(lastLogin).format('DD, MMM YY, HH:MM')}</span>
  // };

  const getLastLogin = (lastLogin) => {
    const bg = getLoginTimeColor(lastLogin);

    return (
      <Tooltip label={`Last login: ${moment(lastLogin).fromNow()}`}>
        <span className={`${bg} px-3 py-1 rounded-md text-xs text-gray-700`}>
          {moment(lastLogin).format("DD MMM, hh:mm A")}
        </span>
      </Tooltip>
    );
  };


  const getTime = (item) => {
    return (
      <div>
        {item.attendanceTime ? (
          <div className="flex gap-1 flex-col">
            <span className="text-gray-600 text-sm">
              {moment(item.attendanceTime, 'HH:mm:ss').format('hh:mm A')}
            </span>
            <span className="text-gray-400 text-xs">{item.propName}</span>
          </div>
        ) : (
          <span className="text-gray-600 text-sm">-</span>
        )}
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Role",
          accessor: "role",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Role",
        accessor: "role",
      },
    //   {
    //     Header: "Salary",
    //     accessor: "salary",
    //   },
      {
        Header: "Last Login",
        accessor: "createdAt",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Role:</strong> {data[rowIndex].Role}
                        </li>

                        <li className="flex gap-2">
                          <strong>Attendance Status:</strong> {data[rowIndex].attendanceStatus}
                        </li>
                        <li className="flex gap-2">
                          <strong>Check In:</strong> {data[rowIndex].checkIn}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {/* {apiData?.length === 0 && <NotFoundModel />} */}
    </>
  );
};
const UserImageWrapper = tw.div` flex items-center gap-2`;

// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
// const MenuOptions = tw.div`absolute bottom-10 right-0 py-2 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const ActionBtnWrapper = tw.div`flex items-center gap-1 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
export default Tables;
